"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var Table = /** @class */ (function () {
    function Table(documentObject) {
        // Initialize sort and expand from constructor
        // If dom not loaded yet, please call this methods again.
        this.setSorting(documentObject);
        this.setExpanding(documentObject);
        this.setClickableRows(documentObject);
    }
    Table.prototype.setSorting = function (documentObject) {
        var asc = false;
        eventsHelper_1.default.live('.js-table-sortable th.c-table__sort-column', 'click', function (event, th) {
            var table = th.closest('.js-table');
            sortColumn(table, th);
        }, documentObject);
        eventsHelper_1.default.live('.js-table-sortable th.c-table__sort-column', 'keyup', function (event, th) {
            var table = th.closest('.js-table');
            if (event.keyCode === 13) {
                event.preventDefault();
                sortColumn(table, th);
            }
        }, documentObject);
        var sortColumn = function (table, th) {
            if (table) {
                if (!asc) {
                    th.classList.add("is-asc");
                    th.classList.remove("is-desc");
                }
                else {
                    th.classList.add("is-desc");
                    th.classList.remove("is-asc");
                }
                Array.from(table.querySelectorAll('tbody tr'))
                    .sort(comparer(Array.from(th.parentNode.children).indexOf(th), !asc ? true : false))
                    .forEach(function (tr) { return table.querySelector('tbody').appendChild(tr); });
                asc ? asc = false : asc = true;
            }
        };
        var getCellValue = function (tr, idx) { return tr.children[idx].innerText || tr.children[idx].textContent; };
        var comparer = function (idx, asc) { return function (a, b) { return (function (v1, v2) {
            return v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2);
        })(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx)); }; };
    };
    Table.prototype.setExpanding = function (documentObject) {
        eventsHelper_1.default.live('.c-table__primary', 'click', function (event, expandRow) {
            toggleRows(expandRow);
        }, documentObject);
        eventsHelper_1.default.live('.c-table__primary', 'keyup', function (event, expandRow) {
            if (event.keyCode === 13) {
                event.preventDefault();
                toggleRows(expandRow);
            }
        }, documentObject);
        var toggleRows = function (expandRow) {
            var table = expandRow.closest('.js-table.js-table-expandable');
            if (table) {
                var rowsToShow = [];
                var nextSibling = expandRow.nextElementSibling;
                while (nextSibling) {
                    if (!nextSibling.classList.contains("c-table__secondary")) {
                        break;
                    }
                    rowsToShow.push(nextSibling);
                    nextSibling = nextSibling.nextElementSibling;
                }
                var expanded = expandRow.getAttribute("aria-expanded");
                if (expanded == "true") {
                    expanded = "false";
                }
                else {
                    expanded = "true";
                }
                expandRow.setAttribute("aria-expanded", expanded);
                expandRow.classList.toggle("is-showing");
                for (var i = 0; i < rowsToShow.length; i++) {
                    rowsToShow[i].classList.toggle("active");
                    var hidden = rowsToShow[i].getAttribute("aria-hidden");
                    if (hidden == "true") {
                        hidden = "false";
                    }
                    else {
                        hidden = "true";
                    }
                    rowsToShow[i].setAttribute("aria-hidden", hidden);
                }
            }
        };
    };
    Table.prototype.setClickableRows = function (documentObject) {
        eventsHelper_1.default.live('.js-table tr.c-table__clickable-row', 'click', function (event, tr) {
            var table = tr.closest('.js-table');
            clickRow(table, tr);
        }, documentObject);
        eventsHelper_1.default.live('.js-table tr.c-table__clickable-row', 'keyup', function (event, tr) {
            var table = tr.closest('.js-table');
            if (event.keyCode === 13) {
                event.preventDefault();
                clickRow(table, tr);
            }
        }, documentObject);
        var clickRow = function (table, tr) {
            if (table) {
                var url = tr.dataset.url;
                if (url && url !== "") {
                    window.location.href = url;
                }
            }
        };
    };
    return Table;
}());
exports.default = Table;
